import {Event} from "components/work-settings/event/Event";
import {useEffect, useState} from "react";
import {ACTION_TYPE} from "../../../constants/constant";
import {useFetch} from "../../../services/useFetch";
import {INITIAL_DATA_FILTER} from "../../../configs/work-settings/configTableEvent";
import {formatDateMoment, getAllQueryParams, removeTargetBlank, setQueryParams} from "../../../utils/utils";
import {useValidation} from "../../../hooks/useValidation";
import {useLocation, useSearchParams} from "react-router-dom";
import { API_EVENT } from "services/apiEvent";

const INITIAL_STATE = {
    date: null,
    name: null,
    description: null
}

const VALIDATION = {
    date: {
        required: 'Tanggal event wajib diisi'
    },
    name: {
        required: 'Nama event wajib diisi'
    }
}

export const EventContainer = () => {
    const location = useLocation()
    const {data: eventList, fetching: getEventList, isLoading} = useFetch(API_EVENT.LIST)
    const {fetching: createEvent, isLoading: isCreating} = useFetch(API_EVENT.CREATE)
    const {fetching: updateEvent, isLoading: isUpdating} = useFetch(API_EVENT.UPDATE)
    const {fetching: deleteEvent, isLoading: isDeleting} = useFetch(API_EVENT.DELETE)
    const [eventDetail, setEventDetail] = useState(INITIAL_STATE)
    const [previewEvent, setPreviewEvent] = useState(INITIAL_STATE)
    const [deleteId, setDeleteId] = useState(null)
    const [actionType, setActionType] = useState(ACTION_TYPE.CREATE)
    const [isShowToast, setIsShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const {errorForm, clearErrorForm, validateForm} = useValidation({schema: VALIDATION })
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [modal, setModal] = useState({
        delete: false,
        form: false,
        limit: false,
        preview: false,
    })

    useEffect(() => {
        fetchEventList({...query})
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({...query, ...queryParams})
        setSearchParams(params, {replace: true})
    }

    const setShowModal = (item) => {
        setModal({...modal, ...item})
    }

    const clearToast = () => {
        setIsShowToast(false)
        setToastMessage('')
    }

    const setShowToast = (message, itemModal) => {
        setShowModal(itemModal)
        setIsShowToast(true)
        setToastMessage(message)
    }

    const fetchEventList = (item = query) => {
        getEventList(item)
    }

    const onClickItemHandler = ({id, item, actionType}) => {
        switch (actionType) {
            case ACTION_TYPE.CREATE:
                setEventDetail(INITIAL_STATE)
                setActionType(ACTION_TYPE.CREATE)
                setShowModal({form: true})
                clearErrorForm()
                break
            case ACTION_TYPE.EDIT:
                setEventDetail({...item, date: formatDateMoment(item.date, 'YYYY-MM-DD')})
                setActionType(ACTION_TYPE.EDIT)
                setShowModal({form: true})
                clearErrorForm()
                break
            case ACTION_TYPE.PREVIEW:
                setPreviewEvent({...item, date: formatDateMoment(item.date, 'YYYY-MM-DD')})
                setEventDetail({...item, date: formatDateMoment(item.date, 'YYYY-MM-DD')})
                setModal({...modal, preview: true})
                break
            default:
                setDeleteId(id)
                setShowModal({delete: true})
        }
    }

    const onDelete = () => {
        deleteEvent({}, deleteId)
            .then(() => {
                setShowToast('Event Deleted !!', {delete: false})
                if (getEventList?.data?.result?.length === 1 && Number(query?.page) !== 1) {
                    onChangeQuery({page: 1})
                } else {
                    fetchEventList()
                }
            })
    }

    const onChangeValue = (item, name) => {
        const newData = name ? {[name]: item} : {[item?.name]: item?.value}
        setEventDetail({...eventDetail, ...newData})
    }

    const onSubmitForm = () => {
        validateForm(eventDetail).then(() => {
            const {id, ...payload} = eventDetail
            payload.description = removeTargetBlank(payload?.description)
            if (actionType === ACTION_TYPE.CREATE) {
                createEvent(payload)
                    .then(() => {
                        setShowToast('Event Created !!', {form: false})
                        fetchEventList()
                    })
            } else {
                updateEvent(payload, id)
                    .then(() => {
                        setShowToast('Event Updated !!', {form: false})
                        fetchEventList()
                        setPreviewEvent({...eventDetail})
                    })
            }
        })
    }

    const props = {
        dataList: eventList?.data,
        modal,
        isShowToast,
        toastMessage,
        eventDetail,
        previewEvent,
        isLoading,
        onClickItemHandler,
        clearToast,
        query,
        isCreating,
        isUpdating,
        isDeleting,
        actionType,
        onChangeQuery,
        setShowModal,
        onDelete,
        onChangeValue,
        onSubmitForm,
        errorForm,
    }

    return (
        <Event {...props}/>
    )
}
